import { render, staticRenderFns } from "./role-assignment-instance-condition.component.vue?vue&type=template&id=07fa498a&scoped=true"
import script from "./role-assignment-instance-condition.component.vue?vue&type=script&lang=ts"
export * from "./role-assignment-instance-condition.component.vue?vue&type=script&lang=ts"
import style0 from "./role-assignment-instance-condition.component.vue?vue&type=style&index=0&id=07fa498a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fa498a",
  null
  
)

export default component.exports